import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SelectField from '../global/fields/SelectField';
import { apiUrl } from '../../constants/apiConsts';
import { getHeaders } from '../../api/helpers';

function UpdateNationality({ fk, hide, value, updateFieldData }) {
  const [closeModal, updateCloseModal] = useState(true);
  const [nationalitiesGroupped, setNationalitiesGroupped] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    async function fetchNationalities() {
      try {
        const request = new Request(`${apiUrl}/content/nationality_list`, {
          method: 'GET',
          headers: getHeaders(),
        });

        const response = await fetch(request);
        const data = await response.json();

        if (data && data.nationalities) {
          const nationalityOptions = data.nationalities.map((country) => ({
            value: country.id,
            label: country.name,
            displayName: country.name,
            flag: country.flag_icon,
          }));

          // Group list
          let datas = nationalityOptions.reduce((r, e) => {
            // get first letter of name of current element
            let title = e.displayName[0];
            // if there is no property in accumulator with this letter create it
            if (!r[title]) r[title] = { title, options: [e] };
            // if there is push current element to children array for that letter
            else r[title].options.push(e);
            // return accumulator
            return r;
          }, {});

          let result = Object.values(datas);

          setNationalitiesGroupped(result);
          setNationalities(nationalityOptions);
          setIsLoading(false);
        }

        if (!response.ok) {
          setIsLoading(false);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        setIsLoading(false);
        console.error('Failed to fetch nationalities:', error);
      }
    }
    fetchNationalities();
  }, []);

  if (isLoading) return null;

  return (
    <div className="modal-content update_nationality">
      <div className="modal-header bg-white">
        <h5 className="modal-title">Nationality</h5>
      </div>
      <div className="modal-body">
        <SelectField
          placeholder={'Select Nationality'}
          options={nationalitiesGroupped}
          key={fk}
          fk={fk}
          value={value}
          showSearch={true}
          optGroup={true}
          onSearch={(text) => setSearchText(text)}
          optionFilterProp={'label'}
          notFoundContent={`Cannot find any Nationalities that match ${searchText}`}
          updateFieldData={(fk, values, error) => {
            const nationality = nationalities.filter((item) => item.value === values);
            const displayName = nationality.length ? nationality[0].displayName : '';
            const displayFlag = nationality.length ? nationality[0].flag : '';

            updateFieldData(fk, values, error, displayName, displayFlag);
            if (!closeModal) {
              hide();
            }

            if (closeModal) updateCloseModal(false);
          }}
        />
      </div>
      <div className="modal-footer mt-3">
        <button
          type="button"
          disabled={false}
          className={`button update_nationality__button`}
          onClick={hide}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

UpdateNationality.propTypes = {
  hide: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  updateValue: PropTypes.func.isRequired,
};

export default UpdateNationality;
